import {
  login,
  logout,
  getInfo,
  getMenuList
} from '@/api/user'
import {
  getToken,
  setToken,
  removeToken,
  setStroage,
  removeStroage
} from '@/utils/auth'
import {
  resetRouter
} from '@/router'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  routerList: [],
  userRouter: ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROUTER: (state, list) => {
    state.routerList = JSON.stringify(list)
  },
  SET_USER: (state) => {
    state.userRouter = state.token
  }
}

const actions = {
  // user login
  login({
    commit
  }, userInfo) {
    const {
      username,
      password
    } = userInfo
    return new Promise((resolve, reject) => {
      login({
        username: username.trim(),
        password: password
      }).then(response => {
        const {
          data
        } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        commit('SET_ROUTER', response.data.auth_router)
        setStroage('vue_admin_template_token', data.token)
        setStroage('auth_router', JSON.stringify(response.data.auth_router))
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const {
          data
        } = response

        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const {
          name,
          avatar
        } = data

        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        removeToken()
        resetRouter()
        removeStroage('vue_admin_template_token')
        removeStroage('auth_router')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({
    commit
  }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      removeStroage('vue_admin_template_token')
      removeStroage('auth_router')
      resolve()
    })
  }
 
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
